export const STORE_ADVERT = 'advert';
export const STORE_AUTH = 'auth';
export const STORE_CATEGORY = 'category';
export const STORE_NAV_MENU = 'navMenu';
export const STORE_NOTIFICATION = 'notification';
export const STORE_ROUTER = 'router';
export const STORE_SUBSCRIPTION = 'subscription';
export const STORE_SUBSCRIPTION_PLAN = 'subscription_plan';
export const STORE_TAG = 'tag';
export const STORE_VIDEO = 'video';



// WEBPACK FOOTER //
// ./src/app/constants/stores.ts